import { render, staticRenderFns } from "./AppMaintenance.vue?vue&type=template&id=77becb2c&scoped=true"
import script from "./AppMaintenance.vue?vue&type=script&lang=js"
export * from "./AppMaintenance.vue?vue&type=script&lang=js"
import style0 from "./AppMaintenance.vue?vue&type=style&index=0&id=77becb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77becb2c",
  null
  
)

export default component.exports